import React from "react";

import { ConfigContextValue } from "../../types";

export const ConfigContext = React.createContext({} as ConfigContextValue);
